/**
 * Country and Timezone Configuration ported from Mobile App
 */
export const COUNTRIES_LIST = [
  {
    "name": "Afghanistan",
    "code": "+93",
    "timezones": [
      "Asia/Kabul"
    ]
  },
  {
    "name": "Aland Islands",
    "code": "+358",
    "timezones": [
      "Europe/Mariehamn"
    ]
  },
  {
    "name": "Albania",
    "code": "+355",
    "timezones": [
      "Europe/Tirane"
    ]
  },
  {
    "name": "Algeria",
    "code": "+213",
    "timezones": [
      "Africa/Algiers"
    ]
  },
  {
    "name": "American Samoa",
    "code": "+1",
    "timezones": [
      "Pacific/Pago_Pago"
    ]
  },
  {
    "name": "Andorra",
    "code": "+376",
    "timezones": [
      "Europe/Andorra"
    ]
  },
  {
    "name": "Angola",
    "code": "+244",
    "timezones": [
      "Africa/Luanda"
    ]
  },
  {
    "name": "Anguilla",
    "code": "+1",
    "timezones": [
      "America/Anguilla"
    ]
  },
  {
    "name": "Antarctica",
    "code": "+672",
    "timezones": [
      "Antarctica/Casey",
      "Antarctica/Davis",
      "Antarctica/DumontDUrville",
      "Antarctica/Mawson",
      "Antarctica/McMurdo",
      "Antarctica/Palmer",
      "Antarctica/Rothera",
      "Antarctica/Syowa",
      "Antarctica/Troll",
      "Antarctica/Vostok"
    ]
  },
  {
    "name": "Antigua and Barbuda",
    "code": "+1",
    "timezones": [
      "America/Antigua"
    ]
  },
  {
    "name": "Argentina",
    "code": "+54",
    "timezones": [
      "America/Argentina/Buenos_Aires",
      "America/Argentina/Catamarca",
      "America/Argentina/Cordoba",
      "America/Argentina/Jujuy",
      "America/Argentina/La_Rioja",
      "America/Argentina/Mendoza",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Salta",
      "America/Argentina/San_Juan",
      "America/Argentina/San_Luis",
      "America/Argentina/Tucuman",
      "America/Argentina/Ushuaia"
    ]
  },
  {
    "name": "Armenia",
    "code": "+374",
    "timezones": [
      "Asia/Yerevan"
    ]
  },
  {
    "name": "Aruba",
    "code": "+297",
    "timezones": [
      "America/Aruba"
    ]
  },
  {
    "name": "Australia",
    "code": "+61",
    "timezones": [
      "Antarctica/Macquarie",
      "Australia/Adelaide",
      "Australia/Brisbane",
      "Australia/Broken_Hill",
      "Australia/Currie",
      "Australia/Darwin",
      "Australia/Eucla",
      "Australia/Hobart",
      "Australia/Lindeman",
      "Australia/Lord_Howe",
      "Australia/Melbourne",
      "Australia/Perth",
      "Australia/Sydney"
    ]
  },
  {
    "name": "Austria",
    "code": "+43",
    "timezones": [
      "Europe/Vienna"
    ]
  },
  {
    "name": "Azerbaijan",
    "code": "+994",
    "timezones": [
      "Asia/Baku"
    ]
  },
  {
    "name": "Bahrain",
    "code": "+973",
    "timezones": [
      "Asia/Bahrain"
    ]
  },
  {
    "name": "Bangladesh",
    "code": "+880",
    "timezones": [
      "Asia/Dhaka"
    ]
  },
  {
    "name": "Barbados",
    "code": "+1",
    "timezones": [
      "America/Barbados"
    ]
  },
  {
    "name": "Belarus",
    "code": "+375",
    "timezones": [
      "Europe/Minsk"
    ]
  },
  {
    "name": "Belgium",
    "code": "+32",
    "timezones": [
      "Europe/Brussels"
    ]
  },
  {
    "name": "Belize",
    "code": "+501",
    "timezones": [
      "America/Belize"
    ]
  },
  {
    "name": "Benin",
    "code": "+229",
    "timezones": [
      "Africa/Porto-Novo"
    ]
  },
  {
    "name": "Bermuda",
    "code": "+1",
    "timezones": [
      "Atlantic/Bermuda"
    ]
  },
  {
    "name": "Bhutan",
    "code": "+975",
    "timezones": [
      "Asia/Thimphu"
    ]
  },
  {
    "name": "Bolivia",
    "code": "+591",
    "timezones": [
      "America/La_Paz"
    ]
  },
  {
    "name": "Bonaire, Sint Eustatius and Saba",
    "code": "+599",
    "timezones": [
      "America/Kralendijk"
    ]
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "+387",
    "timezones": [
      "Europe/Sarajevo"
    ]
  },
  {
    "name": "Botswana",
    "code": "+267",
    "timezones": [
      "Africa/Gaborone"
    ]
  },
  {
    "name": "Bouvet Island",
    "code": "+0055",
    "timezones": [
      "Europe/Oslo"
    ]
  },
  {
    "name": "Brazil",
    "code": "+55",
    "timezones": [
      "America/Araguaina",
      "America/Bahia",
      "America/Belem",
      "America/Boa_Vista",
      "America/Campo_Grande",
      "America/Cuiaba",
      "America/Eirunepe",
      "America/Fortaleza",
      "America/Maceio",
      "America/Manaus",
      "America/Noronha",
      "America/Porto_Velho",
      "America/Recife",
      "America/Rio_Branco",
      "America/Santarem",
      "America/Sao_Paulo"
    ]
  },
  {
    "name": "British Indian Ocean Territory",
    "code": "+246",
    "timezones": [
      "Indian/Chagos"
    ]
  },
  {
    "name": "Brunei",
    "code": "+673",
    "timezones": [
      "Asia/Brunei"
    ]
  },
  {
    "name": "Bulgaria",
    "code": "+359",
    "timezones": [
      "Europe/Sofia"
    ]
  },
  {
    "name": "Burkina Faso",
    "code": "+226",
    "timezones": [
      "Africa/Ouagadougou"
    ]
  },
  {
    "name": "Burundi",
    "code": "+257",
    "timezones": [
      "Africa/Bujumbura"
    ]
  },
  {
    "name": "Cambodia",
    "code": "+855",
    "timezones": [
      "Asia/Phnom_Penh"
    ]
  },
  {
    "name": "Cameroon",
    "code": "+237",
    "timezones": [
      "Africa/Douala"
    ]
  },
  {
    "name": "Canada",
    "code": "+1",
    "timezones": [
      "America/Atikokan",
      "America/Blanc-Sablon",
      "America/Cambridge_Bay",
      "America/Creston",
      "America/Dawson",
      "America/Dawson_Creek",
      "America/Edmonton",
      "America/Fort_Nelson",
      "America/Glace_Bay",
      "America/Goose_Bay",
      "America/Halifax",
      "America/Inuvik",
      "America/Iqaluit",
      "America/Moncton",
      "America/Nipigon",
      "America/Pangnirtung",
      "America/Rainy_River",
      "America/Rankin_Inlet",
      "America/Regina",
      "America/Resolute",
      "America/St_Johns",
      "America/Swift_Current",
      "America/Thunder_Bay",
      "America/Toronto",
      "America/Vancouver",
      "America/Whitehorse",
      "America/Winnipeg",
      "America/Yellowknife"
    ]
  },
  {
    "name": "Cape Verde",
    "code": "+238",
    "timezones": [
      "Atlantic/Cape_Verde"
    ]
  },
  {
    "name": "Cayman Islands",
    "code": "+1",
    "timezones": [
      "America/Cayman"
    ]
  },
  {
    "name": "Central African Republic",
    "code": "+236",
    "timezones": [
      "Africa/Bangui"
    ]
  },
  {
    "name": "Chad",
    "code": "+235",
    "timezones": [
      "Africa/Ndjamena"
    ]
  },
  {
    "name": "Chile",
    "code": "+56",
    "timezones": [
      "America/Punta_Arenas",
      "America/Santiago",
      "Pacific/Easter",
      "America/Coyhaique"
    ]
  },
  {
    "name": "China",
    "code": "+86",
    "timezones": [
      "Asia/Shanghai",
      "Asia/Urumqi"
    ]
  },
  {
    "name": "Christmas Island",
    "code": "+61",
    "timezones": [
      "Indian/Christmas"
    ]
  },
  {
    "name": "Cocos (Keeling) Islands",
    "code": "+61",
    "timezones": [
      "Indian/Cocos"
    ]
  },
  {
    "name": "Colombia",
    "code": "+57",
    "timezones": [
      "America/Bogota"
    ]
  },
  {
    "name": "Comoros",
    "code": "+269",
    "timezones": [
      "Indian/Comoro"
    ]
  },
  {
    "name": "Congo",
    "code": "+242",
    "timezones": [
      "Africa/Brazzaville"
    ]
  },
  {
    "name": "Cook Islands",
    "code": "+682",
    "timezones": [
      "Pacific/Rarotonga"
    ]
  },
  {
    "name": "Costa Rica",
    "code": "+506",
    "timezones": [
      "America/Costa_Rica"
    ]
  },
  {
    "name": "Croatia",
    "code": "+385",
    "timezones": [
      "Europe/Zagreb"
    ]
  },
  {
    "name": "Cuba",
    "code": "+53",
    "timezones": [
      "America/Havana"
    ]
  },
  {
    "name": "Curaçao",
    "code": "+599",
    "timezones": [
      "America/Curacao"
    ]
  },
  {
    "name": "Cyprus",
    "code": "+357",
    "timezones": [
      "Asia/Famagusta",
      "Asia/Nicosia"
    ]
  },
  {
    "name": "Czech Republic",
    "code": "+420",
    "timezones": [
      "Europe/Prague"
    ]
  },
  {
    "name": "Democratic Republic of the Congo",
    "code": "+243",
    "timezones": [
      "Africa/Kinshasa",
      "Africa/Lubumbashi"
    ]
  },
  {
    "name": "Denmark",
    "code": "+45",
    "timezones": [
      "Europe/Copenhagen"
    ]
  },
  {
    "name": "Djibouti",
    "code": "+253",
    "timezones": [
      "Africa/Djibouti"
    ]
  },
  {
    "name": "Dominica",
    "code": "+1",
    "timezones": [
      "America/Dominica"
    ]
  },
  {
    "name": "Dominican Republic",
    "code": "+1",
    "timezones": [
      "America/Santo_Domingo"
    ]
  },
  {
    "name": "Ecuador",
    "code": "+593",
    "timezones": [
      "America/Guayaquil",
      "Pacific/Galapagos"
    ]
  },
  {
    "name": "Egypt",
    "code": "+20",
    "timezones": [
      "Africa/Cairo"
    ]
  },
  {
    "name": "El Salvador",
    "code": "+503",
    "timezones": [
      "America/El_Salvador"
    ]
  },
  {
    "name": "Equatorial Guinea",
    "code": "+240",
    "timezones": [
      "Africa/Malabo"
    ]
  },
  {
    "name": "Eritrea",
    "code": "+291",
    "timezones": [
      "Africa/Asmara"
    ]
  },
  {
    "name": "Estonia",
    "code": "+372",
    "timezones": [
      "Europe/Tallinn"
    ]
  },
  {
    "name": "Eswatini",
    "code": "+268",
    "timezones": [
      "Africa/Mbabane"
    ]
  },
  {
    "name": "Ethiopia",
    "code": "+251",
    "timezones": [
      "Africa/Addis_Ababa"
    ]
  },
  {
    "name": "Falkland Islands",
    "code": "+500",
    "timezones": [
      "Atlantic/Stanley"
    ]
  },
  {
    "name": "Faroe Islands",
    "code": "+298",
    "timezones": [
      "Atlantic/Faroe"
    ]
  },
  {
    "name": "Fiji Islands",
    "code": "+679",
    "timezones": [
      "Pacific/Fiji"
    ]
  },
  {
    "name": "Finland",
    "code": "+358",
    "timezones": [
      "Europe/Helsinki"
    ]
  },
  {
    "name": "France",
    "code": "+33",
    "timezones": [
      "Europe/Paris"
    ]
  },
  {
    "name": "French Guiana",
    "code": "+594",
    "timezones": [
      "America/Cayenne"
    ]
  },
  {
    "name": "French Polynesia",
    "code": "+689",
    "timezones": [
      "Pacific/Gambier",
      "Pacific/Marquesas",
      "Pacific/Tahiti"
    ]
  },
  {
    "name": "French Southern Territories",
    "code": "+262",
    "timezones": [
      "Indian/Kerguelen"
    ]
  },
  {
    "name": "Gabon",
    "code": "+241",
    "timezones": [
      "Africa/Libreville"
    ]
  },
  {
    "name": "Georgia",
    "code": "+995",
    "timezones": [
      "Asia/Tbilisi"
    ]
  },
  {
    "name": "Germany",
    "code": "+49",
    "timezones": [
      "Europe/Berlin",
      "Europe/Busingen"
    ]
  },
  {
    "name": "Ghana",
    "code": "+233",
    "timezones": [
      "Africa/Accra"
    ]
  },
  {
    "name": "Gibraltar",
    "code": "+350",
    "timezones": [
      "Europe/Gibraltar"
    ]
  },
  {
    "name": "Greece",
    "code": "+30",
    "timezones": [
      "Europe/Athens"
    ]
  },
  {
    "name": "Greenland",
    "code": "+299",
    "timezones": [
      "America/Danmarkshavn",
      "America/Nuuk",
      "America/Scoresbysund",
      "America/Thule"
    ]
  },
  {
    "name": "Grenada",
    "code": "+1",
    "timezones": [
      "America/Grenada"
    ]
  },
  {
    "name": "Guadeloupe",
    "code": "+590",
    "timezones": [
      "America/Guadeloupe"
    ]
  },
  {
    "name": "Guam",
    "code": "+1",
    "timezones": [
      "Pacific/Guam"
    ]
  },
  {
    "name": "Guatemala",
    "code": "+502",
    "timezones": [
      "America/Guatemala"
    ]
  },
  {
    "name": "Guernsey",
    "code": "+44",
    "timezones": [
      "Europe/Guernsey"
    ]
  },
  {
    "name": "Guinea",
    "code": "+224",
    "timezones": [
      "Africa/Conakry"
    ]
  },
  {
    "name": "Guinea-Bissau",
    "code": "+245",
    "timezones": [
      "Africa/Bissau"
    ]
  },
  {
    "name": "Guyana",
    "code": "+592",
    "timezones": [
      "America/Guyana"
    ]
  },
  {
    "name": "Haiti",
    "code": "+509",
    "timezones": [
      "America/Port-au-Prince"
    ]
  },
  {
    "name": "Heard Island and McDonald Islands",
    "code": "+672",
    "timezones": [
      "Indian/Kerguelen"
    ]
  },
  {
    "name": "Honduras",
    "code": "+504",
    "timezones": [
      "America/Tegucigalpa"
    ]
  },
  {
    "name": "Hong Kong S.A.R.",
    "code": "+852",
    "timezones": [
      "Asia/Hong_Kong"
    ]
  },
  {
    "name": "Hungary",
    "code": "+36",
    "timezones": [
      "Europe/Budapest"
    ]
  },
  {
    "name": "Iceland",
    "code": "+354",
    "timezones": [
      "Atlantic/Reykjavik"
    ]
  },
  {
    "name": "India",
    "code": "+91",
    "timezones": [
      "Asia/Kolkata"
    ]
  },
  {
    "name": "Indonesia",
    "code": "+62",
    "timezones": [
      "Asia/Jakarta",
      "Asia/Jayapura",
      "Asia/Makassar",
      "Asia/Pontianak"
    ]
  },
  {
    "name": "Iran",
    "code": "+98",
    "timezones": [
      "Asia/Tehran"
    ]
  },
  {
    "name": "Iraq",
    "code": "+964",
    "timezones": [
      "Asia/Baghdad"
    ]
  },
  {
    "name": "Ireland",
    "code": "+353",
    "timezones": [
      "Europe/Dublin"
    ]
  },
  {
    "name": "Israel",
    "code": "+972",
    "timezones": [
      "Asia/Jerusalem"
    ]
  },
  {
    "name": "Italy",
    "code": "+39",
    "timezones": [
      "Europe/Rome"
    ]
  },
  {
    "name": "Ivory Coast",
    "code": "+225",
    "timezones": [
      "Africa/Abidjan"
    ]
  },
  {
    "name": "Jamaica",
    "code": "+1",
    "timezones": [
      "America/Jamaica"
    ]
  },
  {
    "name": "Japan",
    "code": "+81",
    "timezones": [
      "Asia/Tokyo"
    ]
  },
  {
    "name": "Jersey",
    "code": "+44",
    "timezones": [
      "Europe/Jersey"
    ]
  },
  {
    "name": "Jordan",
    "code": "+962",
    "timezones": [
      "Asia/Amman"
    ]
  },
  {
    "name": "Kazakhstan",
    "code": "+7",
    "timezones": [
      "Asia/Almaty",
      "Asia/Aqtau",
      "Asia/Aqtobe",
      "Asia/Atyrau",
      "Asia/Oral",
      "Asia/Qostanay",
      "Asia/Qyzylorda"
    ]
  },
  {
    "name": "Kenya",
    "code": "+254",
    "timezones": [
      "Africa/Nairobi"
    ]
  },
  {
    "name": "Kiribati",
    "code": "+686",
    "timezones": [
      "Pacific/Enderbury",
      "Pacific/Kiritimati",
      "Pacific/Tarawa"
    ]
  },
  {
    "name": "Kosovo",
    "code": "+383",
    "timezones": [
      "Europe/Belgrade"
    ]
  },
  {
    "name": "Kuwait",
    "code": "+965",
    "timezones": [
      "Asia/Kuwait"
    ]
  },
  {
    "name": "Kyrgyzstan",
    "code": "+996",
    "timezones": [
      "Asia/Bishkek"
    ]
  },
  {
    "name": "Laos",
    "code": "+856",
    "timezones": [
      "Asia/Vientiane"
    ]
  },
  {
    "name": "Latvia",
    "code": "+371",
    "timezones": [
      "Europe/Riga"
    ]
  },
  {
    "name": "Lebanon",
    "code": "+961",
    "timezones": [
      "Asia/Beirut"
    ]
  },
  {
    "name": "Lesotho",
    "code": "+266",
    "timezones": [
      "Africa/Maseru"
    ]
  },
  {
    "name": "Liberia",
    "code": "+231",
    "timezones": [
      "Africa/Monrovia"
    ]
  },
  {
    "name": "Libya",
    "code": "+218",
    "timezones": [
      "Africa/Tripoli"
    ]
  },
  {
    "name": "Liechtenstein",
    "code": "+423",
    "timezones": [
      "Europe/Vaduz"
    ]
  },
  {
    "name": "Lithuania",
    "code": "+370",
    "timezones": [
      "Europe/Vilnius"
    ]
  },
  {
    "name": "Luxembourg",
    "code": "+352",
    "timezones": [
      "Europe/Luxembourg"
    ]
  },
  {
    "name": "Macau S.A.R.",
    "code": "+853",
    "timezones": [
      "Asia/Macau"
    ]
  },
  {
    "name": "Madagascar",
    "code": "+261",
    "timezones": [
      "Indian/Antananarivo"
    ]
  },
  {
    "name": "Malawi",
    "code": "+265",
    "timezones": [
      "Africa/Blantyre"
    ]
  },
  {
    "name": "Malaysia",
    "code": "+60",
    "timezones": [
      "Asia/Kuala_Lumpur",
      "Asia/Kuching"
    ]
  },
  {
    "name": "Maldives",
    "code": "+960",
    "timezones": [
      "Indian/Maldives"
    ]
  },
  {
    "name": "Mali",
    "code": "+223",
    "timezones": [
      "Africa/Bamako"
    ]
  },
  {
    "name": "Malta",
    "code": "+356",
    "timezones": [
      "Europe/Malta"
    ]
  },
  {
    "name": "Man (Isle of)",
    "code": "+44",
    "timezones": [
      "Europe/Isle_of_Man"
    ]
  },
  {
    "name": "Marshall Islands",
    "code": "+692",
    "timezones": [
      "Pacific/Kwajalein",
      "Pacific/Majuro"
    ]
  },
  {
    "name": "Martinique",
    "code": "+596",
    "timezones": [
      "America/Martinique"
    ]
  },
  {
    "name": "Mauritania",
    "code": "+222",
    "timezones": [
      "Africa/Nouakchott"
    ]
  },
  {
    "name": "Mauritius",
    "code": "+230",
    "timezones": [
      "Indian/Mauritius"
    ]
  },
  {
    "name": "Mayotte",
    "code": "+262",
    "timezones": [
      "Indian/Mayotte"
    ]
  },
  {
    "name": "Mexico",
    "code": "+52",
    "timezones": [
      "America/Bahia_Banderas",
      "America/Cancun",
      "America/Chihuahua",
      "America/Hermosillo",
      "America/Matamoros",
      "America/Mazatlan",
      "America/Merida",
      "America/Mexico_City",
      "America/Monterrey",
      "America/Ojinaga",
      "America/Tijuana",
      "America/Ciudad_Juarez"
    ]
  },
  {
    "name": "Micronesia",
    "code": "+691",
    "timezones": [
      "Pacific/Chuuk",
      "Pacific/Kosrae",
      "Pacific/Pohnpei"
    ]
  },
  {
    "name": "Moldova",
    "code": "+373",
    "timezones": [
      "Europe/Chisinau"
    ]
  },
  {
    "name": "Monaco",
    "code": "+377",
    "timezones": [
      "Europe/Monaco"
    ]
  },
  {
    "name": "Mongolia",
    "code": "+976",
    "timezones": [
      "Asia/Choibalsan",
      "Asia/Hovd",
      "Asia/Ulaanbaatar"
    ]
  },
  {
    "name": "Montenegro",
    "code": "+382",
    "timezones": [
      "Europe/Podgorica"
    ]
  },
  {
    "name": "Montserrat",
    "code": "+1",
    "timezones": [
      "America/Montserrat"
    ]
  },
  {
    "name": "Morocco",
    "code": "+212",
    "timezones": [
      "Africa/Casablanca",
      "Africa/El_Aaiun"
    ]
  },
  {
    "name": "Mozambique",
    "code": "+258",
    "timezones": [
      "Africa/Maputo"
    ]
  },
  {
    "name": "Myanmar",
    "code": "+95",
    "timezones": [
      "Asia/Yangon"
    ]
  },
  {
    "name": "Namibia",
    "code": "+264",
    "timezones": [
      "Africa/Windhoek"
    ]
  },
  {
    "name": "Nauru",
    "code": "+674",
    "timezones": [
      "Pacific/Nauru"
    ]
  },
  {
    "name": "Nepal",
    "code": "+977",
    "timezones": [
      "Asia/Kathmandu"
    ]
  },
  {
    "name": "Netherlands",
    "code": "+31",
    "timezones": [
      "Europe/Amsterdam"
    ]
  },
  {
    "name": "New Caledonia",
    "code": "+687",
    "timezones": [
      "Pacific/Noumea"
    ]
  },
  {
    "name": "New Zealand",
    "code": "+64",
    "timezones": [
      "Pacific/Auckland",
      "Pacific/Chatham"
    ]
  },
  {
    "name": "Nicaragua",
    "code": "+505",
    "timezones": [
      "America/Managua"
    ]
  },
  {
    "name": "Niger",
    "code": "+227",
    "timezones": [
      "Africa/Niamey"
    ]
  },
  {
    "name": "Nigeria",
    "code": "+234",
    "timezones": [
      "Africa/Lagos"
    ]
  },
  {
    "name": "Niue",
    "code": "+683",
    "timezones": [
      "Pacific/Niue"
    ]
  },
  {
    "name": "Norfolk Island",
    "code": "+672",
    "timezones": [
      "Pacific/Norfolk"
    ]
  },
  {
    "name": "North Korea",
    "code": "+850",
    "timezones": [
      "Asia/Pyongyang"
    ]
  },
  {
    "name": "North Macedonia",
    "code": "+389",
    "timezones": [
      "Europe/Skopje"
    ]
  },
  {
    "name": "Northern Mariana Islands",
    "code": "+1",
    "timezones": [
      "Pacific/Saipan"
    ]
  },
  {
    "name": "Norway",
    "code": "+47",
    "timezones": [
      "Europe/Oslo",
      "Arctic/Longyearbyen"
    ]
  },
  {
    "name": "Oman",
    "code": "+968",
    "timezones": [
      "Asia/Muscat"
    ]
  },
  {
    "name": "Pakistan",
    "code": "+92",
    "timezones": [
      "Asia/Karachi"
    ]
  },
  {
    "name": "Palau",
    "code": "+680",
    "timezones": [
      "Pacific/Palau"
    ]
  },
  {
    "name": "Palestinian Territory Occupied",
    "code": "+970",
    "timezones": [
      "Asia/Gaza",
      "Asia/Hebron"
    ]
  },
  {
    "name": "Panama",
    "code": "+507",
    "timezones": [
      "America/Panama"
    ]
  },
  {
    "name": "Papua New Guinea",
    "code": "+675",
    "timezones": [
      "Pacific/Bougainville",
      "Pacific/Port_Moresby"
    ]
  },
  {
    "name": "Paraguay",
    "code": "+595",
    "timezones": [
      "America/Asuncion"
    ]
  },
  {
    "name": "Peru",
    "code": "+51",
    "timezones": [
      "America/Lima"
    ]
  },
  {
    "name": "Philippines",
    "code": "+63",
    "timezones": [
      "Asia/Manila"
    ]
  },
  {
    "name": "Pitcairn Island",
    "code": "+870",
    "timezones": [
      "Pacific/Pitcairn"
    ]
  },
  {
    "name": "Poland",
    "code": "+48",
    "timezones": [
      "Europe/Warsaw"
    ]
  },
  {
    "name": "Portugal",
    "code": "+351",
    "timezones": [
      "Atlantic/Azores",
      "Atlantic/Madeira",
      "Europe/Lisbon"
    ]
  },
  {
    "name": "Puerto Rico",
    "code": "+1",
    "timezones": [
      "America/Puerto_Rico"
    ]
  },
  {
    "name": "Qatar",
    "code": "+974",
    "timezones": [
      "Asia/Qatar"
    ]
  },
  {
    "name": "Reunion",
    "code": "+262",
    "timezones": [
      "Indian/Reunion"
    ]
  },
  {
    "name": "Romania",
    "code": "+40",
    "timezones": [
      "Europe/Bucharest"
    ]
  },
  {
    "name": "Russia",
    "code": "+7",
    "timezones": [
      "Asia/Anadyr",
      "Asia/Barnaul",
      "Asia/Chita",
      "Asia/Irkutsk",
      "Asia/Kamchatka",
      "Asia/Khandyga",
      "Asia/Krasnoyarsk",
      "Asia/Magadan",
      "Asia/Novokuznetsk",
      "Asia/Novosibirsk",
      "Asia/Omsk",
      "Asia/Sakhalin",
      "Asia/Srednekolymsk",
      "Asia/Tomsk",
      "Asia/Ust-Nera",
      "Asia/Vladivostok",
      "Asia/Yakutsk",
      "Asia/Yekaterinburg",
      "Europe/Astrakhan",
      "Europe/Kaliningrad",
      "Europe/Kirov",
      "Europe/Moscow",
      "Europe/Samara",
      "Europe/Saratov",
      "Europe/Ulyanovsk",
      "Europe/Volgograd"
    ]
  },
  {
    "name": "Rwanda",
    "code": "+250",
    "timezones": [
      "Africa/Kigali"
    ]
  },
  {
    "name": "Saint Helena",
    "code": "+290",
    "timezones": [
      "Atlantic/St_Helena"
    ]
  },
  {
    "name": "Saint Kitts and Nevis",
    "code": "+1",
    "timezones": [
      "America/St_Kitts"
    ]
  },
  {
    "name": "Saint Lucia",
    "code": "+1",
    "timezones": [
      "America/St_Lucia"
    ]
  },
  {
    "name": "Saint Pierre and Miquelon",
    "code": "+508",
    "timezones": [
      "America/Miquelon"
    ]
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "code": "+1",
    "timezones": [
      "America/St_Vincent"
    ]
  },
  {
    "name": "Saint-Barthelemy",
    "code": "+590",
    "timezones": [
      "America/St_Barthelemy"
    ]
  },
  {
    "name": "Saint-Martin (French part)",
    "code": "+590",
    "timezones": [
      "America/Marigot"
    ]
  },
  {
    "name": "Samoa",
    "code": "+685",
    "timezones": [
      "Pacific/Apia"
    ]
  },
  {
    "name": "San Marino",
    "code": "+378",
    "timezones": [
      "Europe/San_Marino"
    ]
  },
  {
    "name": "Sao Tome and Principe",
    "code": "+239",
    "timezones": [
      "Africa/Sao_Tome"
    ]
  },
  {
    "name": "Saudi Arabia",
    "code": "+966",
    "timezones": [
      "Asia/Riyadh"
    ]
  },
  {
    "name": "Senegal",
    "code": "+221",
    "timezones": [
      "Africa/Dakar"
    ]
  },
  {
    "name": "Serbia",
    "code": "+381",
    "timezones": [
      "Europe/Belgrade"
    ]
  },
  {
    "name": "Seychelles",
    "code": "+248",
    "timezones": [
      "Indian/Mahe"
    ]
  },
  {
    "name": "Sierra Leone",
    "code": "+232",
    "timezones": [
      "Africa/Freetown"
    ]
  },
  {
    "name": "Singapore",
    "code": "+65",
    "timezones": [
      "Asia/Singapore"
    ]
  },
  {
    "name": "Sint Maarten (Dutch part)",
    "code": "+1721",
    "timezones": [
      "America/Anguilla"
    ]
  },
  {
    "name": "Slovakia",
    "code": "+421",
    "timezones": [
      "Europe/Bratislava"
    ]
  },
  {
    "name": "Slovenia",
    "code": "+386",
    "timezones": [
      "Europe/Ljubljana"
    ]
  },
  {
    "name": "Solomon Islands",
    "code": "+677",
    "timezones": [
      "Pacific/Guadalcanal"
    ]
  },
  {
    "name": "Somalia",
    "code": "+252",
    "timezones": [
      "Africa/Mogadishu"
    ]
  },
  {
    "name": "South Africa",
    "code": "+27",
    "timezones": [
      "Africa/Johannesburg"
    ]
  },
  {
    "name": "South Georgia",
    "code": "+500",
    "timezones": [
      "Atlantic/South_Georgia"
    ]
  },
  {
    "name": "South Korea",
    "code": "+82",
    "timezones": [
      "Asia/Seoul"
    ]
  },
  {
    "name": "South Sudan",
    "code": "+211",
    "timezones": [
      "Africa/Juba"
    ]
  },
  {
    "name": "Spain",
    "code": "+34",
    "timezones": [
      "Africa/Ceuta",
      "Atlantic/Canary",
      "Europe/Madrid"
    ]
  },
  {
    "name": "Sri Lanka",
    "code": "+94",
    "timezones": [
      "Asia/Colombo"
    ]
  },
  {
    "name": "Sudan",
    "code": "+249",
    "timezones": [
      "Africa/Khartoum"
    ]
  },
  {
    "name": "Suriname",
    "code": "+597",
    "timezones": [
      "America/Paramaribo"
    ]
  },
  {
    "name": "Svalbard and Jan Mayen Islands",
    "code": "+47",
    "timezones": [
      "Arctic/Longyearbyen"
    ]
  },
  {
    "name": "Sweden",
    "code": "+46",
    "timezones": [
      "Europe/Stockholm"
    ]
  },
  {
    "name": "Switzerland",
    "code": "+41",
    "timezones": [
      "Europe/Zurich"
    ]
  },
  {
    "name": "Syria",
    "code": "+963",
    "timezones": [
      "Asia/Damascus"
    ]
  },
  {
    "name": "Taiwan",
    "code": "+886",
    "timezones": [
      "Asia/Taipei"
    ]
  },
  {
    "name": "Tajikistan",
    "code": "+992",
    "timezones": [
      "Asia/Dushanbe"
    ]
  },
  {
    "name": "Tanzania",
    "code": "+255",
    "timezones": [
      "Africa/Dar_es_Salaam"
    ]
  },
  {
    "name": "Thailand",
    "code": "+66",
    "timezones": [
      "Asia/Bangkok"
    ]
  },
  {
    "name": "The Bahamas",
    "code": "+1",
    "timezones": [
      "America/Nassau"
    ]
  },
  {
    "name": "The Gambia",
    "code": "+220",
    "timezones": [
      "Africa/Banjul"
    ]
  },
  {
    "name": "Timor-Leste",
    "code": "+670",
    "timezones": [
      "Asia/Dili"
    ]
  },
  {
    "name": "Togo",
    "code": "+228",
    "timezones": [
      "Africa/Lome"
    ]
  },
  {
    "name": "Tokelau",
    "code": "+690",
    "timezones": [
      "Pacific/Fakaofo"
    ]
  },
  {
    "name": "Tonga",
    "code": "+676",
    "timezones": [
      "Pacific/Tongatapu"
    ]
  },
  {
    "name": "Trinidad and Tobago",
    "code": "+1",
    "timezones": [
      "America/Port_of_Spain"
    ]
  },
  {
    "name": "Tunisia",
    "code": "+216",
    "timezones": [
      "Africa/Tunis"
    ]
  },
  {
    "name": "Turkey",
    "code": "+90",
    "timezones": [
      "Europe/Istanbul"
    ]
  },
  {
    "name": "Turkmenistan",
    "code": "+993",
    "timezones": [
      "Asia/Ashgabat"
    ]
  },
  {
    "name": "Turks and Caicos Islands",
    "code": "+1",
    "timezones": [
      "America/Grand_Turk"
    ]
  },
  {
    "name": "Tuvalu",
    "code": "+688",
    "timezones": [
      "Pacific/Funafuti"
    ]
  },
  {
    "name": "Uganda",
    "code": "+256",
    "timezones": [
      "Africa/Kampala"
    ]
  },
  {
    "name": "Ukraine",
    "code": "+380",
    "timezones": [
      "Europe/Kyiv",
      "Europe/Simferopol",
      "Europe/Uzhgorod",
      "Europe/Zaporozhye"
    ]
  },
  {
    "name": "United Arab Emirates",
    "code": "+971",
    "timezones": [
      "Asia/Dubai"
    ]
  },
  {
    "name": "United Kingdom",
    "code": "+44",
    "timezones": [
      "Europe/London"
    ]
  },
  {
    "name": "United States",
    "code": "+1",
    "timezones": [
      "America/Adak",
      "America/Anchorage",
      "America/Boise",
      "America/Chicago",
      "America/Denver",
      "America/Detroit",
      "America/Indiana/Indianapolis",
      "America/Indiana/Knox",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Tell_City",
      "America/Indiana/Vevay",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Juneau",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/Los_Angeles",
      "America/Menominee",
      "America/Metlakatla",
      "America/New_York",
      "America/Nome",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/Phoenix",
      "America/Sitka",
      "America/Yakutat",
      "Pacific/Honolulu"
    ]
  },
  {
    "name": "United States Minor Outlying Islands",
    "code": "+1",
    "timezones": [
      "Pacific/Midway",
      "Pacific/Wake"
    ]
  },
  {
    "name": "Uruguay",
    "code": "+598",
    "timezones": [
      "America/Montevideo"
    ]
  },
  {
    "name": "Uzbekistan",
    "code": "+998",
    "timezones": [
      "Asia/Samarkand",
      "Asia/Tashkent"
    ]
  },
  {
    "name": "Vanuatu",
    "code": "+678",
    "timezones": [
      "Pacific/Efate"
    ]
  },
  {
    "name": "Vatican City State (Holy See)",
    "code": "+379",
    "timezones": [
      "Europe/Vatican"
    ]
  },
  {
    "name": "Venezuela",
    "code": "+58",
    "timezones": [
      "America/Caracas"
    ]
  },
  {
    "name": "Vietnam",
    "code": "+84",
    "timezones": [
      "Asia/Ho_Chi_Minh"
    ]
  },
  {
    "name": "Virgin Islands (British)",
    "code": "+1",
    "timezones": [
      "America/Tortola"
    ]
  },
  {
    "name": "Virgin Islands (US)",
    "code": "+1",
    "timezones": [
      "America/St_Thomas"
    ]
  },
  {
    "name": "Wallis and Futuna Islands",
    "code": "+681",
    "timezones": [
      "Pacific/Wallis"
    ]
  },
  {
    "name": "Western Sahara",
    "code": "+212",
    "timezones": [
      "Africa/El_Aaiun"
    ]
  },
  {
    "name": "Yemen",
    "code": "+967",
    "timezones": [
      "Asia/Aden"
    ]
  },
  {
    "name": "Zambia",
    "code": "+260",
    "timezones": [
      "Africa/Lusaka"
    ]
  },
  {
    "name": "Zimbabwe",
    "code": "+263",
    "timezones": [
      "Africa/Harare"
    ]
  }
];

export const DEFAULT_COUNTRY = COUNTRIES_LIST.find(c => c.name === "United States") || COUNTRIES_LIST[0];
